export interface ImportGrund {
  id                     : number;
  bezeichnung            : string;
  kommentarPflicht       : boolean;
  zulassungsNrChAnzeigen : boolean;
  lieferEngpassAnzeigen  : boolean;
}

export interface ImportGrundAdmin {
  id                     : number;
  bezeichnungDe          : string;
  bezeichnungFr          : string;
  bezeichnungIt          : string;
  sortierung             : number;
  kommentarPflicht       : boolean;
  zulassungsNrChAnzeigen : boolean;
  lieferEngpassAnzeigen  : boolean;
  aktiv                  : boolean;
}

export class ImportGrundAdminCmd {
  id                     ?: number;
  bezeichnungDe           : string  | null = null;
  bezeichnungFr           : string  | null = null;
  bezeichnungIt           : string  | null = null;
  sortierung              : number  | null = null;
  kommentarPflicht        : boolean | null = null;
  zulassungsNrChAnzeigen  : boolean | null = null;
  lieferEngpassAnzeigen   : boolean | null = null;
  aktiv                   : boolean | null = null;

  public constructor(init?: Partial<ImportGrundAdminCmd>) {
    Object.assign(this, init);
  }
}
